import { render, staticRenderFns } from "./BaseGenderItem.vue?vue&type=template&id=f985437e&"
import script from "./BaseGenderItem.vue?vue&type=script&lang=js&"
export * from "./BaseGenderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports